const STATUS_STYLES: Record<string, string> = {
  active: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  pending: 'bg-amber-50 text-amber-700 border-amber-100',
  suspended: 'bg-rose-50 text-rose-700 border-rose-100',
  inactive: 'bg-slate-100 text-slate-600 border-slate-200',
  valid: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  dismiss: 'bg-rose-50 text-rose-700 border-rose-100',
  en_attente: 'bg-amber-50 text-amber-700 border-amber-100',
  en_transit: 'bg-blue-50 text-blue-700 border-blue-100',
  livré: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  livree: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  annulé: 'bg-rose-50 text-rose-700 border-rose-100',
  en_cours: 'bg-blue-50 text-blue-700 border-blue-100',
};

interface StatusBadgeProps {
  status: string;
  label?: string;
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? 'bg-slate-50 text-slate-600 border-slate-200';
  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold uppercase border ${style}`}>
      {label ?? status.replace(/_/g, ' ')}
    </span>
  );
}
